import React, { useState} from "react";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { apiEndPoints } from "../../api/network/apiEndPoints";
import { useForm } from "react-hook-form";
import { postForm } from "../../api/redux/contact";
import {Helmet, HelmetProvider} from "react-helmet-async";
import ContactForm from "../../components/ContactForm";



const Contact = () => {



    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Contact</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledSection>
                <Container>
                    <Row className={'person-wrap'}>
                        <Col lg={10} sm={12}>
                            <div className="person-details">
                                <ContactForm/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledSection>
        </HelmetProvider>
    );
};

const StyledSection = styled.section`
  .main-heading::after {
    position: absolute;
    content: "";
    background: unset;
    height: 0px !important;
    width: 97%;
    bottom: 0px;
  }

  .person {
    position: relative;
    padding-top: calc(500 / 470 * 100%);
  }

  .person-details p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  }

  /* Tablet desktop :768px. */
  @media (min-width: 768px) and (max-width: 991px) {
    padding-left: 30px;
    .person {
      margin-left: 15px;
    }
  }
`;

export default Contact;
